(function(){
  var hdr=document.getElementById('hdr');
  var heroBg=document.querySelector('.hero-bg');
  var quoteBg=document.querySelector('.quote-bg');
  if(!document.querySelector('.hero')) hdr && hdr.classList.add('solid');
  window.addEventListener('scroll',function(){
    var y=window.scrollY;
    if(hdr && document.querySelector('.hero')) hdr.classList.toggle('scrolled', y>80);
    if(heroBg) heroBg.style.transform='translateY('+(y*0.28)+'px)';
    var qb=document.querySelector('.quote');
    if(quoteBg&&qb){var r=qb.getBoundingClientRect();quoteBg.style.transform='translateY('+(r.top*-0.12)+'px)';}
  },{passive:true});

  var obs=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');obs.unobserve(e.target);}});},{threshold:.12});
  document.querySelectorAll('.reveal').forEach(function(el){obs.observe(el);});

  // accordions
  document.querySelectorAll('.acc h4').forEach(function(h){h.addEventListener('click',function(){h.parentElement.classList.toggle('open');});});

  // toast + overlay + drawer
  var ov=document.getElementById('ov'), toast=document.getElementById('toast'), tt;
  function showToast(m){if(!toast)return;toast.textContent=m;toast.classList.add('show');clearTimeout(tt);tt=setTimeout(function(){toast.classList.remove('show');},2600);}
  function lock(b){document.body.classList.toggle('locked',b);}
  function closeAll(){ov&&ov.classList.remove('open');var d=document.getElementById('cartDrawer');d&&d.classList.remove('open');var m=document.getElementById('menuDrawer');m&&m.classList.remove('open');lock(false);}
  var menuBtn=document.getElementById('menuBtn');
  if(menuBtn){menuBtn.addEventListener('click',function(e){e.preventDefault();var m=document.getElementById('menuDrawer');if(m){ov&&ov.classList.add('open');m.classList.add('open');lock(true);}});}
  ov&&ov.addEventListener('click',closeAll);
  document.querySelectorAll('[data-close]').forEach(function(b){b.addEventListener('click',closeAll);});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closeAll();});
  function money(c){return '$'+(c/100).toFixed(2);}

  function renderCart(cart){
    var wrap=document.getElementById('cartBody'); if(!wrap)return;
    var badge=document.getElementById('cartCount');
    if(badge){badge.textContent=cart.item_count;badge.classList.toggle('show',cart.item_count>0);}
    if(!cart.items.length){wrap.innerHTML='<div class="empty"><div style="font-size:38px;margin-bottom:14px">▭</div><div>Your cart is empty.</div><a class="pill ghost" href="/collections/all" style="margin-top:20px">Shop best sellers</a></div>';return;}
    var html='';
    cart.items.forEach(function(it){
      html+='<div class="citem"><img class="cthumb" src="'+(it.image? it.image : '')+'"><div style="flex:1"><div class="cn">'+it.product_title+'</div><div class="cp">'+money(it.final_price)+'</div><div class="cqty"><a data-ch="'+it.key+'" data-q="'+(it.quantity-1)+'">−</a><span>'+it.quantity+'</span><a data-ch="'+it.key+'" data-q="'+(it.quantity+1)+'">+</a><a class="crm" data-ch="'+it.key+'" data-q="0">Remove</a></div></div></div>';
    });
    html+='<div class="csub"><span>Subtotal</span><span>'+money(cart.total_price)+'</span></div><a class="pill solid" href="/checkout" style="margin-top:16px">Checkout</a><a class="pill ghost" href="/cart" style="margin-top:10px">View cart</a>';
    wrap.innerHTML=html;
    wrap.querySelectorAll('[data-ch]').forEach(function(b){b.addEventListener('click',function(){changeCart(b.getAttribute('data-ch'), parseInt(b.getAttribute('data-q'),10));});});
  }
  function refreshCart(open){fetch('/cart.js').then(function(r){return r.json();}).then(function(c){renderCart(c);if(open)openCart();});}
  function openCart(){ov&&ov.classList.add('open');var d=document.getElementById('cartDrawer');d&&d.classList.add('open');lock(true);}
  function changeCart(key,qty){fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})}).then(function(r){return r.json();}).then(function(c){renderCart(c);});}

  var cartBtn=document.getElementById('cartBtn');
  if(cartBtn){cartBtn.addEventListener('click',function(e){e.preventDefault();refreshCart(true);});}
  refreshCart(false);

  // product page
  var pdp=document.querySelector('.pdp');
  if(pdp){
    document.querySelectorAll('.thumbs .t').forEach(function(t){t.addEventListener('click',function(){document.querySelectorAll('.thumbs .t').forEach(function(x){x.classList.remove('active');});t.classList.add('active');var m=document.getElementById('mainImg');if(m)m.src=t.getAttribute('data-img');});});
    var vid=document.getElementById('variantId');
    document.querySelectorAll('.variant').forEach(function(v){v.addEventListener('click',function(){
      document.querySelectorAll('.variant').forEach(function(x){x.classList.remove('active');});v.classList.add('active');
      if(vid)vid.value=v.getAttribute('data-vid');
      var p=v.getAttribute('data-price'),btn=document.getElementById('addBtn');
      if(btn&&p)btn.textContent='Add to cart — '+money(parseInt(p,10));
    });});
    var qv=1, qEl=document.getElementById('qVal');
    var qi=document.getElementById('qInc'),qd=document.getElementById('qDec');
    qi&&qi.addEventListener('click',function(){qv++;qEl.textContent=qv;});
    qd&&qd.addEventListener('click',function(){if(qv>1){qv--;qEl.textContent=qv;}});
    var addBtn=document.getElementById('addBtn');
    addBtn&&addBtn.addEventListener('click',function(e){
      e.preventDefault();
      var id=vid?vid.value:addBtn.getAttribute('data-vid');
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:id,quantity:qv})})
        .then(function(r){return r.json();}).then(function(){showToast('Added to your cart');refreshCart(true);});
    });
  }
})();
